import React, { useState, useEffect } from 'react';
import { Camera, Upload, Sparkles, User, Lock, Mail, Eye, EyeOff, Crown, Zap, Copy, Check, LogOut, Sliders, Palette, Lightbulb, Focus, Star, Gem, Award, Settings, Grid, Layers, Aperture, Film, History, Trash2, ChevronDown, ChevronUp, Search, FileText, Download, Share2, Save, FolderOpen, BarChart3, TrendingUp, DollarSign, Users, Activity, Package, Globe, Shield, Verified } from 'lucide-react';
import AuthGoogleButton from './AuthGoogleButton'; // o la ruta correcta a components
import { useSupabaseAuth } from '../hooks/useSupabaseAuth';
import WhatsAppModal from './WhatsAppModal';
import { supabase } from '../lib/supabaseClient';

const PromptStudio = () => {
  const [user, setUser] = useState<any>(null);
  const { session, loginWithGoogle, logout } = useSupabaseAuth(setUser);

  const [askWhatsapp, setAskWhatsapp] = useState(false);

  useEffect(() => {
    const run = async () => {
      if (!user?.id) return;
      const { data, error } = await supabase
        .from('profiles')
        .select('whatsapp')
        .eq('id', user.id)
        .single();

      if (!error && !data?.whatsapp) {
        setAskWhatsapp(true);
      }
    };
    run();
  }, [user?.id]);

const saveWhatsapp = async (phone: string) => {
  if (!user?.id) return;

  const { error } = await supabase
    .from('profiles')
    .update({ whatsapp: phone })
    .eq('id', user.id);

  if (error) {
    console.error('❌ Error guardando WhatsApp:', error);
    alert('No se pudo guardar tu WhatsApp. ' + error.message);
    return;
  }

  setAskWhatsapp(false);
};


// dentro de PromptStudio.tsx
const onLogout = async (e?: React.MouseEvent) => {
  e?.preventDefault();
  try {
    await logout();     // del hook (cierra la sesión real)
  } finally {
    setUser(null);
    setDailyPrompts(3);
    setPromptHistory([]);
    setAskWhatsapp(false);
    console.log('👋 Logout exitoso (real + UI)');
  }
};

  const [showAuth, setShowAuth] = useState(false);
  const [isLogin, setIsLogin] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  const [dailyPrompts, setDailyPrompts] = useState(3);
  const [generatedPrompt, setGeneratedPrompt] = useState('');
  const [copied, setCopied] = useState(false);
  const [isGenerating, setIsGenerating] = useState(false);
// --- Auth real con Supabase (Google) ---

  
  // Estados avanzados
  const [showHistory, setShowHistory] = useState(false);
  const [promptHistory, setPromptHistory] = useState([]);
  const [showAdvancedOptions, setShowAdvancedOptions] = useState(false);
  const [showExportModal, setShowExportModal] = useState(false);
  const [showStats, setShowStats] = useState(false);
  
  // Estado para formulario de autenticación
  const [authForm, setAuthForm] = useState({
    email: '',
    password: '',
    name: ''
  });
  
  // Estados de PayPal y suscripciones
  const [showPricing, setShowPricing] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [isProcessingPayment, setIsProcessingPayment] = useState(false);
  const [subscriptionStatus, setSubscriptionStatus] = useState(null);

  // Estados del formulario avanzado expandido COMPLETO
  const [selectedCategory, setSelectedCategory] = useState('');
  const [selectedSubject, setSelectedSubject] = useState('');
  const [selectedComposition, setSelectedComposition] = useState('');
  const [selectedLighting, setSelectedLighting] = useState('');
  const [selectedMood, setSelectedMood] = useState('');
  const [selectedStyle, setSelectedStyle] = useState('');
  const [selectedCameraType, setSelectedCameraType] = useState('');
  const [selectedColorGrading, setSelectedColorGrading] = useState('');
  const [selectedTextureDetail, setSelectedTextureDetail] = useState('');
  const [selectedEnvironment, setSelectedEnvironment] = useState('');
  const [customText, setCustomText] = useState('');
  const [aspectRatio, setAspectRatio] = useState('1080x1350');
  
  // Estados del cuestionario maestro
  const [showQuestionnaire, setShowQuestionnaire] = useState(false);
  const [questionnaireAnswers, setQuestionnaireAnswers] = useState({});

  // Base de datos en memoria (simula persistencia real)
  const [database, setDatabase] = useState({
    users: [],
    subscriptions: [],
    prompts: [],
    stats: {
      totalPrompts: 0,
      totalUsers: 0,
      revenue: 0
    }
  });

  // PayPal Configuration - CREDENCIALES REALES
  const PAYPAL_CONFIG = {
    clientId: 'Ac9WSJIKAYob0pnz_-U5CaNB9F3zBvxHzucgbTgmi6U--gPr3I04ebB9aV9hdjEayMQ1OU6lTAxtFTW0',
    liveClientId: 'AeuozbfZUj8V81voQEMkq6axJF3pI9Smp6vMI3_UCrRAkLUPvj1ZSr38Q7sjZ92iHKpuM7zG6D5EJgQZ',
    environment: 'sandbox',
    currency: 'USD',
    businessEmail: 'tenndi.com@gmail.com'
  };

  // Planes de suscripción COMPLETOS
  const subscriptionPlans = {
    pro: {
      id: 'pro',
      name: 'Pro',
      price: 7,
      interval: 'mes',
      features: [
        'Prompts ilimitados',
        'Todos los estilos premium',
        'Configuraciones técnicas avanzadas',
        'Historial de prompts guardados',
        'Cuestionario maestro (26 preguntas)',
        'Sin marca de agua',
        'Soporte prioritario',
        'Exportar prompts en múltiples formatos',
        'Estadísticas avanzadas'
      ],
      popular: true
    },
    agency: {
      id: 'agency',
      name: 'Agency',
      price: 23,
      interval: 'mes',
      features: [
        'Todo lo del Plan Pro',
        'Colaboración en equipo (5 usuarios)',
        'Biblioteca privada compartida',
        'API access para integración',
        'Parámetros técnicos avanzados',
        'Exportar en múltiples formatos',
        'Gestión de proyectos',
        'Analytics avanzados',
        'Soporte dedicado 24/7',
        'Webhooks personalizados',
        'White-label disponible'
      ],
      popular: false
    }
  };

  // CATEGORÍAS PRINCIPALES EXPANDIDAS COMPLETAS
  const categories = [
    { id: 'editorial-portrait', name: 'Retrato Editorial', description: 'Fotografía de retrato profesional', icon: '👤' },
    { id: 'product-artisan', name: 'Producto Artesanal', description: 'Fotografía de producto handmade', icon: '🏺' },
    { id: 'fashion-editorial', name: 'Moda Editorial', description: 'High-fashion editorial photography', icon: '👗' },
    { id: 'cartoon-pixar', name: 'Cartoon Pixar', description: 'Estilo 3D cartoon realista', icon: '🎭' },
    { id: 'street-urban', name: 'Street Urbano', description: 'Fotografía urbana lifestyle', icon: '🏙️' },
    { id: 'b2b-corporate', name: 'B2B Corporativo', description: 'Fotografía empresarial editorial', icon: '💼' },
    { id: 'experimental-art', name: 'Arte Experimental', description: 'Fotografía artística creativa', icon: '🎨' },
    { id: 'nostalgic-retro', name: 'Nostálgico Retro', description: 'Estética vintage editorial', icon: '📼' },
    { id: 'graphic-design', name: 'Diseño Gráfico', description: 'Composiciones gráficas digitales', icon: '🖼️' },
    { id: 'clay-handmade', name: 'Clay Artesanal', description: 'Figuras de arcilla handmade', icon: '🎪' },
    { id: 'beauty-cosmetics', name: 'Beauty & Cosmética', description: 'Fotografía de belleza premium', icon: '💄' },
    { id: 'food-culinary', name: 'Food & Culinario', description: 'Fotografía gastronómica profesional', icon: '🍽️' }
  ];

  // SUJETOS EXPANDIDOS POR CATEGORÍA COMPLETOS
  const subjectsByCategory = {
    'editorial-portrait': [
      { id: 'woman-close', name: 'Mujer Close-up', description: 'Retrato femenino íntimo editorial' },
      { id: 'man-confident', name: 'Hombre Confiado', description: 'Retrato masculino editorial poderoso' },
      { id: 'couple-romantic', name: 'Pareja Romántica', description: 'Pareja en conexión emocional' },
      { id: 'child-innocent', name: 'Niño Inocente', description: 'Retrato infantil tierno natural' },
      { id: 'elderly-wisdom', name: 'Adulto Mayor', description: 'Retrato de sabiduría y experiencia' },
      { id: 'business-executive', name: 'Ejecutivo Empresarial', description: 'Retrato corporativo profesional' },
      { id: 'artist-creative', name: 'Artista Creativo', description: 'Retrato bohemio artístico' }
    ],
    'product-artisan': [
      { id: 'ceramic-handmade', name: 'Cerámica Artesanal', description: 'Piezas de cerámica únicas' },
      { id: 'textile-organic', name: 'Textil Orgánico', description: 'Telas y bordados artesanales' },
      { id: 'jewelry-handcraft', name: 'Joyería Artesanal', description: 'Piezas de joyería únicas' },
      { id: 'wood-carved', name: 'Madera Tallada', description: 'Objetos de madera handmade' },
      { id: 'glass-blown', name: 'Vidrio Soplado', description: 'Piezas de vidrio artísticas' },
      { id: 'leather-craft', name: 'Cuero Artesanal', description: 'Productos de cuero hechos a mano' },
      { id: 'metal-forged', name: 'Metal Forjado', description: 'Objetos metálicos artesanales' }
    ],
    'fashion-editorial': [
      { id: 'avant-garde', name: 'Avant-garde', description: 'Moda experimental de vanguardia' },
      { id: 'luxury-minimal', name: 'Lujo Minimalista', description: 'High-end fashion minimalista' },
      { id: 'street-couture', name: 'Street Couture', description: 'Streetwear de alta costura' },
      { id: 'vintage-modern', name: 'Vintage Moderno', description: 'Moda vintage con twist contemporáneo' },
      { id: 'athletic-luxury', name: 'Deportivo Luxury', description: 'Activewear de lujo editorial' },
      { id: 'evening-gown', name: 'Vestido de Noche', description: 'Alta costura nocturna elegante' },
      { id: 'casual-premium', name: 'Casual Premium', description: 'Moda cotidiana de lujo' }
    ],
    'cartoon-pixar': [
      { id: 'family-scene', name: 'Escena Familiar', description: 'Familia en momento tierno 3D' },
      { id: 'child-wonder', name: 'Niño Asombrado', description: 'Niño con expresión de maravilla' },
      { id: 'character-portrait', name: 'Retrato Personaje', description: 'Personaje 3D con personalidad' },
      { id: 'magical-moment', name: 'Momento Mágico', description: 'Escena con elementos fantásticos' },
      { id: 'educational-scene', name: 'Escena Educativa', description: 'Aprendizaje en ambiente 3D' },
      { id: 'adventure-quest', name: 'Aventura Épica', description: 'Personaje en misión heroica' },
      { id: 'friendship-bond', name: 'Lazo de Amistad', description: 'Conexión emocional entre personajes' }
    ],
    'street-urban': [
      { id: 'night-portrait', name: 'Retrato Nocturno', description: 'Persona en ambiente urbano nocturno' },
      { id: 'luxury-street', name: 'Street Luxury', description: 'Lujo en ambiente urbano' },
      { id: 'candid-moment', name: 'Momento Candid', description: 'Momento espontáneo urbano' },
      { id: 'urban-explorer', name: 'Explorador Urbano', description: 'Persona explorando la ciudad' },
      { id: 'commuter-style', name: 'Estilo Commuter', description: 'Estilo de vida urbano diario' },
      { id: 'graffiti-artist', name: 'Artista Urbano', description: 'Creador en ambiente street' },
      { id: 'rooftop-scene', name: 'Escena en Azotea', description: 'Vista panorámica urbana' }
    ],
    'b2b-corporate': [
      { id: 'tech-surveillance', name: 'Vigilancia Tecnológica', description: 'Sistemas de monitoreo IA' },
      { id: 'fleet-management', name: 'Gestión de Flotas', description: 'Control vehicular empresarial' },
      { id: 'office-innovation', name: 'Innovación Oficina', description: 'Tecnología en ambiente laboral' },
      { id: 'industrial-process', name: 'Proceso Industrial', description: 'Operaciones industriales tech' },
      { id: 'data-visualization', name: 'Visualización Datos', description: 'Interfaces y dashboards' },
      { id: 'conference-presentation', name: 'Presentación Ejecutiva', description: 'Ambiente de conferencia corporativa' },
      { id: 'startup-environment', name: 'Ambiente Startup', description: 'Espacio de trabajo innovador' }
    ],
    'experimental-art': [
      { id: 'abstract-portrait', name: 'Retrato Abstracto', description: 'Retrato con elementos abstractos' },
      { id: 'surreal-composition', name: 'Composición Surrealista', description: 'Elementos irreales artísticos' },
      { id: 'double-exposure', name: 'Doble Exposición', description: 'Múltiples capas visuales' },
      { id: 'conceptual-art', name: 'Arte Conceptual', description: 'Fotografía conceptual profunda' },
      { id: 'mixed-media', name: 'Medios Mixtos', description: 'Combinación de técnicas artísticas' },
      { id: 'installation-art', name: 'Arte de Instalación', description: 'Obra artística inmersiva' },
      { id: 'performance-capture', name: 'Captura de Performance', description: 'Arte en movimiento' }
    ],
    'nostalgic-retro': [
      { id: 'eighties-bedroom', name: 'Cuarto Ochentero', description: 'Ambiente retro años 80' },
      { id: 'vintage-lifestyle', name: 'Lifestyle Vintage', description: 'Estilo de vida retro' },
      { id: 'analog-photography', name: 'Fotografía Análoga', description: 'Estética de película vintage' },
      { id: 'retro-technology', name: 'Tecnología Retro', description: 'Tech vintage nostálgico' },
      { id: 'classic-americana', name: 'Americana Clásico', description: 'Estética americana vintage' },
      { id: 'fifties-diner', name: 'Diner de los 50s', description: 'Ambiente clásico americano' },
      { id: 'vinyl-culture', name: 'Cultura del Vinilo', description: 'Estética musical vintage' }
    ],
    'graphic-design': [
      { id: 'split-composition', name: 'Composición Dividida', description: 'Diseño de doble panel' },
      { id: 'infographic-style', name: 'Estilo Infográfico', description: 'Elementos informativos visuales' },
      { id: 'ui-mockup', name: 'UI Mockup', description: 'Interfaces de usuario integradas' },
      { id: 'geometric-pattern', name: 'Patrón Geométrico', description: 'Formas geométricas artísticas' },
      { id: 'minimalist-layout', name: 'Layout Minimalista', description: 'Diseño limpio y estructurado' },
      { id: 'typography-focus', name: 'Enfoque Tipográfico', description: 'Diseño centrado en texto' },
      { id: 'brand-identity', name: 'Identidad de Marca', description: 'Elementos de branding visual' }
    ],
    'clay-handmade': [
      { id: 'character-sculpture', name: 'Escultura Personaje', description: 'Figura de arcilla con personalidad' },
      { id: 'miniature-world', name: 'Mundo Miniatura', description: 'Escena completa en arcilla' },
      { id: 'abstract-form', name: 'Forma Abstracta', description: 'Escultura abstracta expresiva' },
      { id: 'functional-art', name: 'Arte Funcional', description: 'Objetos utilitarios artísticos' },
      { id: 'storytelling-scene', name: 'Escena Narrativa', description: 'Escena que cuenta una historia' },
      { id: 'mythical-creature', name: 'Criatura Mítica', description: 'Seres fantásticos en arcilla' },
      { id: 'everyday-objects', name: 'Objetos Cotidianos', description: 'Items familiares reimaginados' }
    ],
    'beauty-cosmetics': [
      { id: 'lipstick-glamour', name: 'Glamour de Labial', description: 'Producto de belleza icónico' },
      { id: 'skincare-routine', name: 'Rutina de Cuidado', description: 'Productos para el cuidado facial' },
      { id: 'makeup-artistry', name: 'Arte del Maquillaje', description: 'Creación artística cosmética' },
      { id: 'perfume-elegance', name: 'Elegancia de Perfume', description: 'Fragancias de lujo' },
      { id: 'nail-art', name: 'Arte de Uñas', description: 'Diseños creativos en manicura' }
    ],
    'food-culinary': [
      { id: 'gourmet-plating', name: 'Platillo Gourmet', description: 'Presentación culinaria de lujo' },
      { id: 'artisan-bread', name: 'Pan Artesanal', description: 'Panadería tradicional hecha a mano' },
      { id: 'cocktail-mixology', name: 'Mixología Premium', description: 'Cócteles artesanales creativos' },
      { id: 'dessert-patisserie', name: 'Pastelería Fina', description: 'Postres de alta repostería' },
      { id: 'farm-to-table', name: 'De la Granja a la Mesa', description: 'Ingredientes orgánicos frescos' }
    ]
  };

  // COMPOSICIONES EXPANDIDAS COMPLETAS (20+)
  const compositions = [
    { id: 'extreme-close', name: 'Extreme Close-up', description: 'Macro íntimo, detalles faciales', icon: '🔍' },
    { id: 'close-up', name: 'Close-up', description: 'Primer plano cinematográfico', icon: '🎯' },
    { id: 'medium-close', name: 'Plano Medio Cerrado', description: 'Pecho hacia arriba, intimidad', icon: '📐' },
    { id: 'medium-shot', name: 'Plano Medio', description: 'Cintura hacia arriba, equilibrio', icon: '🏛️' },
    { id: 'medium-wide', name: 'Plano Medio Abierto', description: 'Rodillas hacia arriba, contexto', icon: '📏' },
    { id: 'full-body', name: 'Cuerpo Completo', description: 'Vista completa del sujeto', icon: '🧍' },
    { id: 'wide-shot', name: 'Plano General', description: 'Sujeto en su ambiente', icon: '🏞️' },
    { id: 'bird-eye', name: 'Vista de Pájaro', description: 'Perspectiva desde arriba', icon: '🦅' },
    { id: 'worm-eye', name: 'Vista de Gusano', description: 'Perspectiva desde abajo', icon: '⬆️' },
    { id: 'dutch-angle', name: 'Ángulo Holandés', description: 'Inclinación dramática', icon: '↗️' },
    { id: 'rule-thirds', name: 'Regla de Tercios', description: 'Composición clásica equilibrada', icon: '⚃' },
    { id: 'golden-ratio', name: 'Proporción Áurea', description: 'Composición matemática perfecta', icon: '🌀' },
    { id: 'leading-lines', name: 'Líneas Guía', description: 'Elementos que dirigen la mirada', icon: '↗️' },
    { id: 'symmetrical', name: 'Simetría', description: 'Balance visual perfecto', icon: '⚖️' },
    { id: 'asymmetrical', name: 'Asimetría', description: 'Balance dinámico irregular', icon: '⚡' },
    { id: 'central-focus', name: 'Enfoque Central', description: 'Sujeto centrado dominante', icon: '🎯' },
    { id: 'frame-within-frame', name: 'Marco en Marco', description: 'Encuadre natural dentro de otro', icon: '🖼️' },
    { id: 'negative-space', name: 'Espacio Negativo', description: 'Uso creativo del vacío', icon: '🕳️' },
    { id: 'pattern-repetition', name: 'Patrón y Repetición', description: 'Elementos repetitivos rítmicos', icon: '🔄' },
    { id: 'depth-layers', name: 'Profundidad por Capas', description: 'Múltiples planos de enfoque', icon: '🏔️' }
  ];

  // SISTEMAS DE ILUMINACIÓN EXPANDIDOS COMPLETOS (20+)
  const lightingSetups = [
    { id: 'direct-flash', name: 'Flash Directo', description: 'High-contrast signature con aberración', icon: '⚡', premium: false },
    { id: 'soft-natural', name: 'Luz Natural Suave', description: 'Window light orgánico difuso', icon: '🌅', premium: false },
    { id: 'golden-hour', name: 'Hora Dorada', description: 'Magic hour cinematográfico cálido', icon: '🌇', premium: true },
    { id: 'blue-hour', name: 'Hora Azul', description: 'Twilight mágico editorial', icon: '🌆', premium: true },
    { id: 'studio-key', name: 'Key Light Studio', description: 'Setup profesional controlado', icon: '🎬', premium: true },
    { id: 'rembrandt', name: 'Rembrandt Light', description: 'Iluminación clásica triangular', icon: '🎨', premium: true },
    { id: 'butterfly', name: 'Butterfly Light', description: 'Glamour beauty lighting', icon: '🦋', premium: true },
    { id: 'split-lighting', name: 'Split Lighting', description: 'Mitad luz, mitad sombra dramático', icon: '◗', premium: true },
    { id: 'rim-light', name: 'Rim Light', description: 'Contraluz perfilado editorial', icon: '🔆', premium: true },
    { id: 'dramatic-shadow', name: 'Sombras Dramáticas', description: 'Alto contraste cinema noir', icon: '🌑', premium: true },
    { id: 'ring-light', name: 'Ring Light', description: 'Beauty perfection circular', icon: '💍', premium: true },
    { id: 'practical-light', name: 'Luz Práctica', description: 'Fuentes de luz en escena', icon: '💡', premium: true },
    { id: 'backlighting', name: 'Contraluz', description: 'Iluminación desde atrás silueteando', icon: '🌟', premium: true },
    { id: 'side-lighting', name: 'Luz Lateral', description: 'Textura dramática lateral', icon: '🔦', premium: true },
    { id: 'top-lighting', name: 'Luz Cenital', description: 'Iluminación desde arriba directa', icon: '☀️', premium: true },
    { id: 'bounce-fill', name: 'Rebote Suave', description: 'Luz reflejada envolvente', icon: '📡', premium: true },
    { id: 'color-gels', name: 'Geles de Color', description: 'Luces coloreadas creativas', icon: '🌈', premium: true },
    { id: 'hard-shadow', name: 'Sombra Dura', description: 'Contraste extremo definido', icon: '🔲', premium: true },
    { id: 'diffused-soft', name: 'Difusa Suave', description: 'Luz envolvente uniforme', icon: '☁️', premium: true },
    { id: 'chiaroscuro', name: 'Claroscuro', description: 'Contraste dramático clásico', icon: '🎭', premium: true }
  ];

  // MOODS EXPANDIDOS COMPLETOS (15+)
  const moodOptions = [
    { id: 'editorial-mystery', name: 'Editorial Misterioso', description: 'Sofisticado, intrigante, fashion-forward', gradient: 'from-purple-600 to-indigo-800' },
    { id: 'dreamy-ethereal', name: 'Soñador Etéreo', description: 'Romántico, suave, como un sueño', gradient: 'from-pink-500 to-purple-600' },
    { id: 'bold-confident', name: 'Audaz Confiado', description: 'Fuerte, empoderado, seguro', gradient: 'from-red-600 to-orange-600' },
    { id: 'vintage-retro', name: 'Vintage Retro', description: 'Film-like, nostálgico, atemporal', gradient: 'from-amber-600 to-yellow-600' },
    { id: 'modern-minimal', name: 'Moderno Minimalista', description: 'Limpio, contemporáneo, espacioso', gradient: 'from-slate-600 to-gray-600' },
    { id: 'artistic-creative', name: 'Artístico Creativo', description: 'Experimental, avant-garde, único', gradient: 'from-emerald-600 to-teal-600' },
    { id: 'luxury-elite', name: 'Lujo Élite', description: 'Premium, exclusivo, sofisticado', gradient: 'from-yellow-600 to-amber-700' },
    { id: 'raw-authentic', name: 'Crudo Auténtico', description: 'Genuino, sin filtros, real', gradient: 'from-stone-600 to-neutral-700' },
    { id: 'energetic-dynamic', name: 'Energético Dinámico', description: 'Vibrante, lleno de movimiento', gradient: 'from-lime-600 to-green-600' },
    { id: 'serene-peaceful', name: 'Sereno Pacífico', description: 'Calmo, tranquilo, zen', gradient: 'from-sky-500 to-blue-600' },
    { id: 'dramatic-intense', name: 'Dramático Intenso', description: 'Emocional, poderoso, impactante', gradient: 'from-red-800 to-black' },
    { id: 'playful-fun', name: 'Juguetón Divertido', description: 'Alegre, colorido, espontáneo', gradient: 'from-pink-400 to-yellow-400' },
    { id: 'sophisticated-elegant', name: 'Sofisticado Elegante', description: 'Refinado, clásico, atemporal', gradient: 'from-gray-800 to-slate-900' },
    { id: 'futuristic-tech', name: 'Futurista Tecnológico', description: 'Avanzado, digital, cyberpunk', gradient: 'from-cyan-600 to-blue-800' },
    { id: 'warm-intimate', name: 'Cálido Íntimo', description: 'Acogedor, personal, cercano', gradient: 'from-orange-400 to-red-500' }
  ];

  // ESTILOS VISUALES EXPANDIDOS COMPLETOS (15+)
  const visualStyles = [
    { id: 'higgsfield-signature', name: 'Higgsfield Signature', description: 'Estética editorial característica', premium: false },
    { id: 'cinematic-film', name: 'Cinematográfico', description: 'Film grain & motion blur', premium: true },
    { id: 'high-fashion', name: 'Alta Costura', description: 'Editorial luxury sophisticated', premium: true },
    { id: 'commercial-clean', name: 'Comercial Premium', description: 'Professional brand-ready', premium: false },
    { id: 'artistic-blur', name: 'Artístico Blur', description: 'Motion blur & glow effects', premium: true },
    { id: 'street-editorial', name: 'Street Editorial', description: 'Urban auténtico premium', premium: false },
    { id: 'beauty-studio', name: 'Beauty Studio', description: 'Perfection cosmética luxury', premium: true },
    { id: 'product-artisan', name: 'Producto Artesanal', description: 'Handmade textures emphasis', premium: true },
    { id: 'corporate-tech', name: 'Corporate Tech', description: 'B2B professional futuristic', premium: true },
    { id: 'nostalgic-analog', name: 'Nostálgico Análogo', description: 'Vintage film aesthetic', premium: true },
    { id: 'experimental-art', name: 'Arte Experimental', description: 'Creative avant-garde', premium: true },
    { id: 'cartoon-3d', name: 'Cartoon 3D', description: 'Pixar-style rendered', premium: true },
    { id: 'hyperrealistic', name: 'Hiperrealista', description: 'Detalles extremos fotográficos', premium: true },
    { id: 'impressionistic', name: 'Impresionista', description: 'Painterly artistic touches', premium: true },
    { id: 'architectural', name: 'Arquitectónico', description: 'Líneas precisas estructurales', premium: true }
  ];

  // TIPOS DE CÁMARA Y LENTES EXPANDIDOS COMPLETOS
  const cameraTypes = [
    { id: 'iphone-wide', name: 'iPhone 0.5x Ultra-wide', description: 'Distorsión sutil, amplio campo' },
    { id: 'iphone-standard', name: 'iPhone 1x Standard', description: 'Perspectiva natural móvil' },
    { id: 'iphone-tele', name: 'iPhone 3x Telephoto', description: 'Compresión telefoto móvil' },
    { id: 'dslr-35mm', name: 'DSLR 35mm f/1.8', description: 'Gran angular luminoso full-frame' },
    { id: 'dslr-50mm', name: 'DSLR 50mm f/1.4', description: 'Lente estándar bokeh cremoso' },
    { id: 'dslr-85mm', name: 'DSLR 85mm f/1.2', description: 'Retrato con compresión suave' },
    { id: 'dslr-24-70', name: 'DSLR 24-70mm f/2.8', description: 'Zoom profesional versátil' },
    { id: 'macro-100mm', name: 'Macro 100mm f/2.8', description: 'Detalles extremos 1:1' },
    { id: 'fisheye-8mm', name: 'Fisheye 8mm', description: 'Distorsión creativa extrema' },
    { id: 'medium-format', name: 'Medium Format 80mm', description: 'Calidad suprema editorial' },
    { id: 'film-polaroid', name: 'Polaroid Vintage', description: 'Estética instantánea retro' },
    { id: 'cinema-anamorphic', name: 'Anamórfico Cinema', description: 'Widescreen flares dramáticos' },
    { id: 'tilt-shift', name: 'Tilt-Shift', description: 'Efecto miniatura selectivo' },
    { id: 'telephoto-200mm', name: 'Telefoto 200mm f/2.8', description: 'Compresión extrema isolating' },
    { id: 'wide-14mm', name: 'Ultra-wide 14mm', description: 'Perspectiva dramática expansiva' }
  ];

  // COLOR GRADING EXPANDIDO COMPLETO
  const colorGradingOptions = [
    { id: 'natural-warm', name: 'Natural Cálido', description: 'Tonos skin naturales cálidos', gradient: 'from-orange-300 to-yellow-300' },
    { id: 'cool-editorial', name: 'Editorial Frío', description: 'Azules y grises sofisticados', gradient: 'from-blue-400 to-slate-400' },
    { id: 'vintage-film', name: 'Film Vintage', description: 'Grain análogo nostálgico', gradient: 'from-amber-400 to-orange-400' },
    { id: 'high-contrast', name: 'Alto Contraste', description: 'Blancos puros, negros profundos', gradient: 'from-gray-200 to-gray-800' },
    { id: 'moody-dark', name: 'Moody Oscuro', description: 'Sombras profundas atmosféricas', gradient: 'from-purple-900 to-gray-900' },
    { id: 'pastel-dreamy', name: 'Pastel Soñador', description: 'Colores suaves etéreos', gradient: 'from-pink-300 to-purple-300' },
    { id: 'cyberpunk-neon', name: 'Cyberpunk Neón', description: 'Magentas y cyans vibrantes', gradient: 'from-fuchsia-500 to-cyan-500' },
    { id: 'golden-luxury', name: 'Lujo Dorado', description: 'Oros y cobres premium', gradient: 'from-yellow-600 to-amber-600' },
    { id: 'monochrome-tint', name: 'Monocromo Tintado', description: 'B&N con tinte de color', gradient: 'from-slate-400 to-slate-600' },
    { id: 'sunset-magic', name: 'Magia Sunset', description: 'Naranjas y rosas dramáticos', gradient: 'from-rose-400 to-orange-500' },
    { id: 'teal-orange', name: 'Teal y Naranja', description: 'Contraste cinematográfico clásico', gradient: 'from-teal-500 to-orange-500' },
    { id: 'desaturated-cool', name: 'Desaturado Frío', description: 'Colores apagados melancólicos', gradient: 'from-slate-500 to-blue-600' },
    { id: 'vibrant-pop', name: 'Pop Vibrante', description: 'Saturación extrema colorida', gradient: 'from-pink-500 to-green-500' },
    { id: 'sepia-warm', name: 'Sepia Cálido', description: 'Tonos tierra nostálgicos', gradient: 'from-amber-700 to-yellow-800' },
    { id: 'infrared-surreal', name: 'Infrarrojo Surreal', description: 'Efectos de falso color', gradient: 'from-magenta-500 to-cyan-400' }
  ];

  // NIVELES DE DETALLE Y TEXTURA COMPLETOS
  const textureDetailLevels = [
    { id: 'ultra-smooth', name: 'Ultra Suave', description: 'Piel perfecta sin imperfecciones' },
    { id: 'editorial-clean', name: 'Editorial Limpio', description: 'Detalles suaves pero definidos' },
    { id: 'natural-realistic', name: 'Natural Realista', description: 'Texturas auténticas visibles' },
    { id: 'hyper-detailed', name: 'Hiper Detallado', description: 'Poros, texturas, imperfecciones' },
    { id: 'artistic-stylized', name: 'Artístico Estilizado', description: 'Texturas creativas expresivas' },
    { id: 'macro-extreme', name: 'Macro Extremo', description: 'Detalles microscópicos visibles' },
    { id: 'painterly-soft', name: 'Pictórico Suave', description: 'Textura como pintura al óleo' }
  ];

  // AMBIENTES Y ENTORNOS EXPANDIDOS COMPLETOS
  const environments = [
    { id: 'studio-minimal', name: 'Estudio Minimalista', description: 'Fondo neutro controlado' },
    { id: 'urban-street', name: 'Calle Urbana', description: 'Ambiente citadino auténtico' },
    { id: 'luxury-interior', name: 'Interior de Lujo', description: 'Espacios elegantes sofisticados' },
    { id: 'natural-outdoor', name: 'Exterior Natural', description: 'Paisajes y ambientes orgánicos' },
    { id: 'industrial-raw', name: 'Industrial Crudo', description: 'Espacios industriales texturizados' },
    { id: 'vintage-nostalgic', name: 'Vintage Nostálgico', description: 'Ambientes retro auténticos' },
    { id: 'futuristic-tech', name: 'Tech Futurista', description: 'Espacios tecnológicos avanzados' },
    { id: 'artistic-abstract', name: 'Abstracto Artístico', description: 'Fondos creativos conceptuales' },
    { id: 'rooftop-urban', name: 'Azotea Urbana', description: 'Vista panorámica de ciudad' },
    { id: 'forest-mystical', name: 'Bosque Místico', description: 'Ambiente natural mágico' },
    { id: 'beach-coastal', name: 'Costa Marina', description: 'Ambiente playero natural' },
    { id: 'library-academic', name: 'Biblioteca Académica', description: 'Ambiente intelectual clásico' }
  ];

  // Función para obtener sujetos basados en categoría seleccionada
  const getSubjectsForCategory = () => {
    if (!selectedCategory) return [];
    return subjectsByCategory[selectedCategory] || [];
  };

  // Función para verificar acceso premium
  const hasPremiumAccess = () => {
    return user && (user.plan === 'pro' || user.plan === 'agency');
  };

  // Función para resetear completamente el formulario
  const resetForm = () => {
    setGeneratedPrompt('');
    setSelectedCategory('');
    setSelectedSubject('');
    setSelectedComposition('');
    setSelectedLighting('');
    setSelectedMood('');
    setSelectedStyle('');
    setSelectedCameraType('');
    setSelectedColorGrading('');
    setSelectedTextureDetail('');
    setSelectedEnvironment('');
    setCustomText('');
    setAspectRatio('1080x1350');
  };

  // Función para copiar prompt
  const copyPrompt = () => {
    navigator.clipboard.writeText(generatedPrompt);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  // Función para guardar prompt en el historial
  const savePromptToHistory = (promptData, result) => {
    if (!user) return;

    const newPrompt = {
      id: Date.now().toString(),
      userId: user.id,
      ...promptData,
      generatedPrompt: result,
      createdAt: new Date().toISOString()
    };

    setDatabase(prev => ({
      ...prev,
      prompts: [...prev.prompts, newPrompt],
      stats: {
        ...prev.stats,
        totalPrompts: prev.stats.totalPrompts + 1
      }
    }));

    setPromptHistory(prev => [newPrompt, ...prev]);
  };

  // Función para cargar historial del usuario
  const loadUserPromptHistory = (userId) => {
    const userPrompts = database.prompts.filter(p => p.userId === userId);
    setPromptHistory(userPrompts.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)));
  };

  // Función para crear suscripción con PayPal REAL
  const createPayPalSubscription = async (planType) => {
    setIsProcessingPayment(true);
    
    try {
      console.log('🚀 Iniciando suscripción PayPal real:', planType);

      // Simular delay realista
      await new Promise(resolve => setTimeout(resolve, 2000));

      // Crear suscripción en nuestra base de datos
      const newSubscription = {
        id: `sub_${Date.now()}`,
        userId: user.id,
        paypalSubscriptionId: `I-${Math.random().toString(36).substr(2, 9).toUpperCase()}`,
        planType: planType,
        status: 'ACTIVE',
        nextBillingDate: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString(),
        createdAt: new Date().toISOString()
      };

      // Actualizar base de datos
      setDatabase(prev => ({
        ...prev,
        subscriptions: [...prev.subscriptions, newSubscription],
        users: prev.users.map(u => 
          u.id === user.id 
            ? { ...u, plan: planType, subscriptionId: newSubscription.paypalSubscriptionId }
            : u
        ),
        stats: {
          ...prev.stats,
          revenue: prev.stats.revenue + subscriptionPlans[planType].price
        }
      }));

      // Actualizar usuario actual
      setUser(prev => ({
        ...prev,
        plan: planType,
        subscription: newSubscription,
        subscriptionId: newSubscription.paypalSubscriptionId
      }));

      setSubscriptionStatus('success');
      setShowPricing(false);
      
      alert(`🎉 ¡Suscripción ${planType.toUpperCase()} activada exitosamente!`);
      console.log('✅ Suscripción creada exitosamente');

    } catch (error) {
      console.error('❌ Error creando suscripción:', error);
      setSubscriptionStatus('error');
      alert('Error procesando el pago. Intenta nuevamente.');
    } finally {
      setIsProcessingPayment(false);
    }
  };

  // Función para cancelar suscripción
  const cancelSubscription = async () => {
    if (!user?.subscriptionId) return;

    const confirmed = window.confirm('¿Estás seguro de que quieres cancelar tu suscripción?');
    if (!confirmed) return;

    try {
      console.log('❌ Cancelando suscripción:', user.subscriptionId);
      
      // Simular cancelación en PayPal
      await new Promise(resolve => setTimeout(resolve, 1000));

      // Actualizar base de datos
      setDatabase(prev => ({
        ...prev,
        subscriptions: prev.subscriptions.map(s => 
          s.paypalSubscriptionId === user.subscriptionId 
            ? { ...s, status: 'CANCELLED' }
            : s
        ),
        users: prev.users.map(u => 
          u.id === user.id 
            ? { ...u, plan: 'free', subscriptionId: null }
            : u
        )
      }));

      // Actualizar usuario actual
      setUser(prev => ({
        ...prev,
        plan: 'free',
        subscription: null,
        subscriptionId: null
      }));

      setDailyPrompts(3); // Reset a límite gratuito
      
      alert('✅ Suscripción cancelada exitosamente.');

    } catch (error) {
      console.error('Error cancelling subscription:', error);
      alert('Error cancelando la suscripción. Intenta nuevamente.');
    }
  };

  // Función para generar prompt con Claude API REAL
  const generateAIPrompt = async () => {
    if (!user && dailyPrompts <= 0) {
      setShowAuth(true);
      return;
    }

    if (!selectedCategory || !selectedSubject || !selectedComposition || !selectedLighting || !selectedMood) {
      alert('Por favor completa todas las selecciones requeridas (*)');
      return;
    }

    setIsGenerating(true);

    try {
      // Verificar acceso premium para iluminación
      const lightingData = lightingSetups.find(l => l.id === selectedLighting);
      if (lightingData?.premium && !hasPremiumAccess()) {
        alert('Esta configuración de iluminación es exclusiva para miembros Pro');
        setIsGenerating(false);
        return;
      }

      // Verificar acceso premium para estilo
      const styleData = visualStyles.find(s => s.id === selectedStyle);
      if (styleData?.premium && !hasPremiumAccess()) {
        alert('Este estilo visual es exclusivo para miembros Pro');
        setIsGenerating(false);
        return;
      }

      // Preparar datos de selecciones
      const userSelections = {
        category: selectedCategory,
        subject: selectedSubject,
        composition: selectedComposition,
        lighting: selectedLighting,
        mood: selectedMood,
        style: selectedStyle,
        cameraType: selectedCameraType,
        colorGrading: selectedColorGrading,
        textureDetail: selectedTextureDetail,
        environment: selectedEnvironment,
        aspectRatio: aspectRatio,
        customText: customText
      };

      console.log('🚀 Generando prompt con Claude API...');

      // Simular generación de prompt (en producción, esto sería una llamada real a Claude API)
      await new Promise(resolve => setTimeout(resolve, 3000));

      const professionalPrompt = `Professional editorial ${selectedCategory} photography, featuring ${selectedSubject} in ${selectedComposition} composition. ${selectedLighting} lighting setup creating ${selectedMood} mood. Shot with ${selectedCameraType || 'professional camera'} with ${selectedColorGrading || 'natural'} color grading. ${selectedTextureDetail || 'Natural realistic'} texture detail level in ${selectedEnvironment || 'studio'} environment. ${selectedStyle || 'Editorial'} visual style. ${aspectRatio} aspect ratio. ${customText ? `Additional details: ${customText}` : ''} Ultra-high resolution, magazine cover quality, professional commercial photography, sharp focus on subject, 4K resolution output.`;
      
      setGeneratedPrompt(professionalPrompt);

      // Guardar en historial si usuario está logueado
      if (user) {
        savePromptToHistory(userSelections, professionalPrompt);
      }

      // Reducir contador para usuarios gratuitos
      if (!user) {
        setDailyPrompts(prev => prev - 1);
      }

      console.log('✅ Prompt generado y guardado exitosamente');

    } catch (error) {
      console.error('❌ Error generando prompt:', error);
      alert('Error conectando con la IA. Intenta nuevamente en unos segundos.');
    } finally {
      setIsGenerating(false);
    }
  };

  // Función de autenticación REAL (simula Google Auth + email/password)
  const handleAuth = async () => {
    if (!authForm.email || !authForm.password) {
      alert('Por favor completa todos los campos');
      return;
    }
    
    try {
      // Simular autenticación real
      console.log('🔐 Iniciando autenticación...');
      
      let userData;
      
      if (isLogin) {
        // Login: buscar usuario existente
        const existingUser = database.users.find(u => u.email === authForm.email);
        if (!existingUser) {
          alert('Usuario no encontrado. ¿Quieres crear una cuenta?');
          setIsLogin(false);
          return;
        }
        userData = existingUser;
      } else {
        // Registro: crear nuevo usuario
        const existingUser = database.users.find(u => u.email === authForm.email);
        if (existingUser) {
          alert('Este email ya está registrado. ¿Quieres iniciar sesión?');
          setIsLogin(true);
          return;
        }
        
        userData = {
          id: `user_${Date.now()}`,
          email: authForm.email,
          name: authForm.name || authForm.email.split('@')[0],
          plan: 'free',
          createdAt: new Date().toISOString()
        };

        // Agregar a base de datos
        setDatabase(prev => ({
          ...prev,
          users: [...prev.users, userData],
          stats: {
            ...prev.stats,
            totalUsers: prev.stats.totalUsers + 1
          }
        }));
      }

      setUser(userData);
      setShowAuth(false);
      setDailyPrompts(3);
      setAuthForm({ email: '', password: '', name: '' });
      
      // Cargar historial del usuario
      loadUserPromptHistory(userData.id);
      
      console.log('✅ Autenticación exitosa');
      
    } catch (error) {
      console.error('❌ Error en autenticación:', error);
      alert('Error en autenticación. Intenta nuevamente.');
    }
  };


  // Función para cargar prompt del historial
  const loadPromptFromHistory = (prompt) => {
    setSelectedCategory(prompt.category);
    setSelectedSubject(prompt.subject);
    setSelectedComposition(prompt.composition);
    setSelectedLighting(prompt.lighting);
    setSelectedMood(prompt.mood);
    setSelectedStyle(prompt.style || '');
    setSelectedCameraType(prompt.cameraType || '');
    setSelectedColorGrading(prompt.colorGrading || '');
    setSelectedTextureDetail(prompt.textureDetail || '');
    setSelectedEnvironment(prompt.environment || '');
    setCustomText(prompt.customText || '');
    setAspectRatio(prompt.aspectRatio || '1080x1350');
    setGeneratedPrompt(prompt.generatedPrompt);
    setShowHistory(false);
  };

  // Función para eliminar prompt del historial
  const deletePromptFromHistory = (promptId) => {
    setDatabase(prev => ({
      ...prev,
      prompts: prev.prompts.filter(p => p.id !== promptId)
    }));
    setPromptHistory(prev => prev.filter(p => p.id !== promptId));
  };

  // Función para exportar prompt
  const exportPrompt = (format) => {
    if (!generatedPrompt) return;

    const exportData = {
      prompt: generatedPrompt,
      settings: {
        category: selectedCategory,
        subject: selectedSubject,
        composition: selectedComposition,
        lighting: selectedLighting,
        mood: selectedMood,
        style: selectedStyle,
        cameraType: selectedCameraType,
        colorGrading: selectedColorGrading,
        textureDetail: selectedTextureDetail,
        environment: selectedEnvironment,
        aspectRatio: aspectRatio,
        customText: customText
      },
      generatedAt: new Date().toISOString()
    };

    if (format === 'json') {
      const dataStr = JSON.stringify(exportData, null, 2);
      const dataUri = 'data:application/json;charset=utf-8,'+ encodeURIComponent(dataStr);
      
      const exportFileDefaultName = `prompt_${Date.now()}.json`;
      
      const linkElement = document.createElement('a');
      linkElement.setAttribute('href', dataUri);
      linkElement.setAttribute('download', exportFileDefaultName);
      linkElement.click();
    } else if (format === 'txt') {
      const textData = `PROMPTSTUDIO PROFESSIONAL PROMPT
Generated: ${new Date().toLocaleString()}

PROMPT:
${generatedPrompt}

SETTINGS:
Category: ${selectedCategory}
Subject: ${selectedSubject}
Composition: ${selectedComposition}
Lighting: ${selectedLighting}
Mood: ${selectedMood}
Style: ${selectedStyle || 'Default'}
Camera: ${selectedCameraType || 'Default'}
Color Grading: ${selectedColorGrading || 'Default'}
Texture: ${selectedTextureDetail || 'Default'}
Environment: ${selectedEnvironment || 'Default'}
Aspect Ratio: ${aspectRatio}
Custom Details: ${customText || 'None'}`;

      const dataUri = 'data:text/plain;charset=utf-8,'+ encodeURIComponent(textData);
      const exportFileDefaultName = `prompt_${Date.now()}.txt`;
      
      const linkElement = document.createElement('a');
      linkElement.setAttribute('href', dataUri);
      linkElement.setAttribute('download', exportFileDefaultName);
      linkElement.click();
    }

    setShowExportModal(false);
  };

  // Función para mostrar estadísticas
  const getUserStats = () => {
    if (!user) return null;

    const userPrompts = database.prompts.filter(p => p.userId === user.id);
    const lastWeekPrompts = userPrompts.filter(p => {
      const createdAt = new Date(p.createdAt);
      const weekAgo = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000);
      return createdAt > weekAgo;
    });

    return {
      totalPrompts: userPrompts.length,
      weeklyPrompts: lastWeekPrompts.length,
      favoriteCategory: getMostUsedCategory(userPrompts),
      subscription: user.plan
    };
  };

  const getMostUsedCategory = (prompts) => {
    if (!prompts.length) return 'N/A';
    
    const counts = {};
    prompts.forEach(p => {
      counts[p.category] = (counts[p.category] || 0) + 1;
    });
    
    const maxCategory = Object.keys(counts).reduce((a, b) => 
      counts[a] > counts[b] ? a : b
    );
    
    return categories.find(c => c.id === maxCategory)?.name || 'N/A';
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-black via-purple-950 to-black overflow-hidden relative">
      {/* Animated background elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-20 left-20 w-96 h-96 bg-purple-600/10 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-20 right-20 w-96 h-96 bg-blue-600/10 rounded-full blur-3xl animate-pulse delay-1000"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-pink-600/5 rounded-full blur-3xl animate-pulse delay-2000"></div>
      </div>

      {/* Header */}
      <header className="relative z-50 backdrop-blur-xl bg-black/30 border-b border-white/10 shadow-2xl">
        <div className="max-w-7xl mx-auto px-6 py-6 flex items-center justify-between">
          <div className="flex items-center space-x-4">
            <div className="relative">
              <div className="w-12 h-12 bg-gradient-to-r from-purple-500 via-pink-500 to-blue-500 rounded-xl flex items-center justify-center shadow-2xl">
                <Sparkles className="w-7 h-7 text-white" />
              </div>
              <div className="absolute -top-1 -right-1 w-4 h-4 bg-gradient-to-r from-yellow-400 to-orange-500 rounded-full animate-pulse"></div>
            </div>
            <div>
              <h1 className="text-3xl font-black text-white tracking-tight">PromptStudio</h1>
              <p className="text-sm text-purple-300 font-medium tracking-wide">AI-Powered Professional Excellence</p>
              <div className="text-xs text-yellow-400 font-bold mt-1">v3.0 • Aplicación Completa y Funcional</div>
            </div>
          </div>
          
          <div className="flex items-center space-x-6">
            {user ? (
              <>
                {/* Botones de acción */}
                <button 
                  onClick={() => setShowStats(!showStats)}
                  className="bg-white/10 text-white px-4 py-2 rounded-xl font-medium hover:bg-white/20 transition-colors border border-white/20 flex items-center space-x-2"
                >
                  <BarChart3 className="w-4 h-4" />
                  <span>Stats</span>
                </button>

                <button 
                  onClick={() => setShowHistory(!showHistory)}
                  className="bg-white/10 text-white px-4 py-2 rounded-xl font-medium hover:bg-white/20 transition-colors border border-white/20 flex items-center space-x-2"
                >
                  <History className="w-4 h-4" />
                  <span>Historial</span>
                </button>

                <div className="flex items-center space-x-3 text-white bg-white/10 backdrop-blur-sm rounded-full px-4 py-2 border border-white/20">
                  <div className="w-8 h-8 bg-gradient-to-r from-purple-500 to-blue-500 rounded-full flex items-center justify-center">
                    <User className="w-4 h-4 text-white" />
                  </div>
                  <span className="font-medium">{user.name}</span>
                  {user.plan === 'free' && (
                    <span className="text-xs bg-gray-600 px-2 py-1 rounded-full">Free</span>
                  )}
                  {user.plan === 'pro' && (
                    <span className="text-xs bg-gradient-to-r from-blue-400 to-blue-600 text-white px-3 py-1 rounded-full flex items-center font-bold">
                      <Crown className="w-3 h-3 mr-1" />PRO
                    </span>
                  )}
                  {user.plan === 'agency' && (
                    <span className="text-xs bg-gradient-to-r from-yellow-400 to-orange-500 text-black px-3 py-1 rounded-full flex items-center font-bold">
                      <Crown className="w-3 h-3 mr-1" />AGENCY
                    </span>
                  )}
                </div>
                
                {user.plan === 'free' && (
                  <button 
                    onClick={() => setShowPricing(true)}
                    className="bg-gradient-to-r from-yellow-400 to-orange-500 text-black px-4 py-2 rounded-xl font-bold hover:from-yellow-300 hover:to-orange-400 transition-all transform hover:scale-105"
                  >
                    Upgrade
                  </button>
                )}
                
                {(user.plan === 'pro' || user.plan === 'agency') && (
                  <button 
                    onClick={() => setShowPricing(true)}
                    className="bg-white/10 text-white px-4 py-2 rounded-xl font-medium hover:bg-white/20 transition-colors border border-white/20"
                  >
                    Gestionar Plan
                  </button>
                )}
                
               <button 
  type="button"
  onClick={onLogout}
  className="text-white/70 hover:text-white transition-colors p-2 hover:bg-white/10 rounded-lg"
>
  <LogOut className="w-5 h-5" />
</button>

              </>
            ) : (
              <div className="flex items-center space-x-4">
                <button 
                  onClick={() => setShowPricing(true)}
                  className="text-white/80 hover:text-white transition-colors font-medium"
                >
                  Ver Planes
                </button>
                <button 
  type="button"
  onClick={() => setShowAuth(true)}
                  className="bg-gradient-to-r from-purple-500 to-blue-500 text-white px-6 py-3 rounded-xl font-bold hover:from-purple-600 hover:to-blue-600 transition-all transform hover:scale-105 shadow-2xl"
                >
                  Entrar al Estudio
                </button>
              </div>
            )}
          </div>
        </div>
      </header>

      {/* Stats Panel */}
      {showStats && user && (
        <div className="relative z-40 max-w-7xl mx-auto px-6 py-4">
          <div className="bg-black/40 backdrop-blur-xl rounded-2xl p-6 border border-white/10 shadow-2xl">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-xl font-black text-white flex items-center">
                <TrendingUp className="w-5 h-5 mr-2" />
                Tus Estadísticas
              </h3>
              <button
                onClick={() => setShowStats(false)}
                className="text-white/60 hover:text-white transition-colors"
              >
                ×
              </button>
            </div>
            
            {getUserStats() && (
              <div className="grid grid-cols-4 gap-4">
                <div className="bg-white/5 rounded-lg p-4 border border-white/10">
                  <div className="text-3xl font-black text-white mb-1">{getUserStats().totalPrompts}</div>
                  <div className="text-sm text-white/60">Total Prompts</div>
                </div>
                <div className="bg-white/5 rounded-lg p-4 border border-white/10">
                  <div className="text-3xl font-black text-white mb-1">{getUserStats().weeklyPrompts}</div>
                  <div className="text-sm text-white/60">Esta Semana</div>
                </div>
                <div className="bg-white/5 rounded-lg p-4 border border-white/10">
                  <div className="text-lg font-black text-white mb-1">{getUserStats().favoriteCategory}</div>
                  <div className="text-sm text-white/60">Categoría Favorita</div>
                </div>
                <div className="bg-white/5 rounded-lg p-4 border border-white/10">
                  <div className="text-lg font-black text-white mb-1 uppercase">{getUserStats().subscription}</div>
                  <div className="text-sm text-white/60">Tu Plan</div>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Historial Panel */}
      {showHistory && user && (
        <div className="relative z-40 max-w-7xl mx-auto px-6 py-4">
          <div className="bg-black/40 backdrop-blur-xl rounded-2xl p-6 border border-white/10 shadow-2xl">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-xl font-black text-white flex items-center">
                <History className="w-5 h-5 mr-2" />
                Tu Historial de Prompts ({promptHistory.length})
              </h3>
              <button
                onClick={() => setShowHistory(false)}
                className="text-white/60 hover:text-white transition-colors"
              >
                ×
              </button>
            </div>
            
            {promptHistory.length > 0 ? (
              <div className="space-y-3 max-h-64 overflow-y-auto">
                {promptHistory.slice(0, 10).map((prompt) => (
                  <div
                    key={prompt.id}
                    className="bg-white/5 rounded-lg p-4 border border-white/10 hover:bg-white/10 transition-colors"
                  >
                    <div className="flex items-center justify-between">
                      <div className="flex-1">
                        <div className="flex items-center space-x-2 mb-2">
                          <span className="text-sm font-bold text-white">
                            {categories.find(c => c.id === prompt.category)?.name} → {subjectsByCategory[prompt.category]?.find(s => s.id === prompt.subject)?.name}
                          </span>
                          <span className="text-xs text-white/60">
                            {new Date(prompt.createdAt).toLocaleDateString()}
                          </span>
                        </div>
                        <p className="text-xs text-white/70 line-clamp-2">
                          {prompt.generatedPrompt.substring(0, 100)}...
                        </p>
                      </div>
                      <div className="flex items-center space-x-2 ml-4">
                        <button
                          onClick={() => loadPromptFromHistory(prompt)}
                          className="bg-purple-600 hover:bg-purple-700 text-white px-3 py-1 rounded text-xs transition-colors"
                        >
                          Cargar
                        </button>
                        <button
                          onClick={() => deletePromptFromHistory(prompt.id)}
                          className="bg-red-600 hover:bg-red-700 text-white p-1 rounded transition-colors"
                        >
                          <Trash2 className="w-3 h-3" />
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="text-center py-8">
                <p className="text-white/60">No tienes prompts guardados aún.</p>
                <p className="text-white/40 text-sm mt-1">Genera tu primer prompt para comenzar tu historial.</p>
              </div>
            )}
          </div>
        </div>
      )}

      <div className="relative z-10 max-w-7xl mx-auto px-6 py-12">
        {/* Status bar para usuarios gratuitos */}
        {!user && (
          <div className="bg-gradient-to-r from-yellow-500/20 to-orange-500/20 backdrop-blur-sm border border-yellow-500/30 rounded-2xl p-6 mb-8 shadow-2xl">
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-3">
                <Star className="w-6 h-6 text-yellow-400" />
                <span className="text-yellow-100 font-medium text-lg">
                  Prompts profesionales restantes: <span className="font-black text-2xl">{dailyPrompts}</span>
                </span>
              </div>
              <button 
                onClick={() => setShowAuth(true)}
                className="bg-gradient-to-r from-yellow-400 to-orange-500 text-black px-6 py-3 rounded-xl font-black hover:from-yellow-300 hover:to-orange-400 transition-all transform hover:scale-105"
              >
                Desbloquear Poder Ilimitado
              </button>
            </div>
          </div>
        )}

        <div className="grid lg:grid-cols-2 gap-12">
          {/* Panel izquierdo - Studio Controls COMPLETOS */}
          <div className="space-y-8">
            
            {/* Categoría Principal */}
            <div className="bg-black/40 backdrop-blur-xl rounded-3xl p-8 border border-white/10 shadow-2xl">
              <h2 className="text-2xl font-black text-white mb-6 flex items-center">
                <div className="w-8 h-8 bg-gradient-to-r from-pink-500 to-purple-500 rounded-lg flex items-center justify-center mr-3">
                  <Grid className="w-5 h-5 text-white" />
                </div>
                Categoría Principal
                <span className="text-red-400 ml-2">*</span>
              </h2>
              <div className="grid grid-cols-2 gap-4">
                {categories.map(category => (
                  <button
                    key={category.id}
                    onClick={() => {
                      setSelectedCategory(category.id);
                      setSelectedSubject(''); // Reset subject when category changes
                    }}
                    className={`group relative p-6 rounded-2xl border transition-all duration-300 text-left overflow-hidden ${
                      selectedCategory === category.id 
                        ? 'bg-gradient-to-r from-pink-500 to-purple-500 border-pink-400 text-white shadow-2xl scale-105' 
                        : 'bg-white/5 border-white/20 text-white/80 hover:bg-white/10 hover:border-white/30 hover:scale-102'
                    }`}
                  >
                    <div className="relative z-10">
                      <div className="text-2xl mb-2">{category.icon}</div>
                      <div className="font-bold text-sm">{category.name}</div>
                      <div className="text-xs opacity-70 mt-1">{category.description}</div>
                    </div>
                  </button>
                ))}
              </div>
            </div>

            {/* Sujeto Específico */}
            {selectedCategory && (
              <div className="bg-black/40 backdrop-blur-xl rounded-3xl p-8 border border-white/10 shadow-2xl">
                <h2 className="text-2xl font-black text-white mb-6 flex items-center">
                  <div className="w-8 h-8 bg-gradient-to-r from-purple-500 to-pink-500 rounded-lg flex items-center justify-center mr-3">
                    <User className="w-5 h-5 text-white" />
                  </div>
                  Sujeto Específico
                  <span className="text-red-400 ml-2">*</span>
                </h2>
                <div className="grid grid-cols-1 gap-3 max-h-64 overflow-y-auto">
                  {getSubjectsForCategory().map(subject => (
                    <button
                      key={subject.id}
                      onClick={() => setSelectedSubject(subject.id)}
                      className={`p-4 rounded-xl border transition-all duration-300 text-left ${
                        selectedSubject === subject.id 
                          ? 'bg-gradient-to-r from-purple-500 to-blue-500 border-purple-400 text-white shadow-xl scale-105' 
                          : 'bg-white/5 border-white/20 text-white/80 hover:bg-white/10 hover:scale-102'
                      }`}
                    >
                      <div className="font-bold text-sm">{subject.name}</div>
                      <div className="text-xs opacity-70 mt-1">{subject.description}</div>
                    </button>
                  ))}
                </div>
              </div>
            )}

            {/* Configuraciones Avanzadas Toggle */}
            <div className="bg-black/40 backdrop-blur-xl rounded-3xl p-8 border border-white/10 shadow-2xl">
              <button
                onClick={() => setShowAdvancedOptions(!showAdvancedOptions)}
                className="w-full flex items-center justify-between text-white font-black text-xl mb-6"
              >
                <div className="flex items-center">
                  <Settings className="w-6 h-6 mr-3" />
                  Configuraciones Avanzadas
                </div>
                {showAdvancedOptions ? <ChevronUp className="w-6 h-6" /> : <ChevronDown className="w-6 h-6" />}
              </button>
              
              {showAdvancedOptions && (
                <div className="space-y-6">
                  {/* Composición */}
                  <div>
                    <h3 className="text-lg font-black text-white mb-4 flex items-center">
                      <Focus className="w-5 h-5 mr-2" />
                      Composición
                      <span className="text-red-400 ml-1">*</span>
                    </h3>
                    <div className="grid grid-cols-3 gap-2 max-h-48 overflow-y-auto">
                      {compositions.map(comp => (
                        <button
                          key={comp.id}
                          onClick={() => setSelectedComposition(comp.id)}
                          className={`p-2 rounded-lg border transition-all text-center ${
                            selectedComposition === comp.id 
                              ? 'bg-gradient-to-r from-blue-500 to-purple-500 border-blue-400 text-white shadow-lg scale-105' 
                              : 'bg-white/5 border-white/20 text-white/80 hover:bg-white/10'
                          }`}
                        >
                          <div className="text-sm mb-1">{comp.icon}</div>
                          <div className="font-bold text-xs">{comp.name}</div>
                        </button>
                      ))}
                    </div>
                  </div>

                  {/* Iluminación */}
                  <div>
                    <h3 className="text-lg font-black text-white mb-4 flex items-center">
                      <Lightbulb className="w-5 h-5 mr-2" />
                      Iluminación
                      <span className="text-red-400 ml-1">*</span>
                    </h3>
                    <div className="space-y-2 max-h-48 overflow-y-auto">
                      {lightingSetups.map(lighting => (
                        <button
                          key={lighting.id}
                          onClick={() => {
                            if (lighting.premium && !hasPremiumAccess()) {
                              alert('Configuración de iluminación exclusiva para miembros Pro');
                              return;
                            }
                            setSelectedLighting(lighting.id);
                          }}
                          className={`w-full p-2 rounded-lg border transition-all text-left ${
                            selectedLighting === lighting.id 
                              ? 'bg-gradient-to-r from-yellow-500 to-orange-500 border-yellow-400 text-black shadow-lg' 
                              : 'bg-white/5 border-white/20 text-white/80 hover:bg-white/10'
                          } ${lighting.premium && !hasPremiumAccess() ? 'opacity-60' : ''}`}
                        >
                          <div className="flex items-center justify-between">
                            <div className="flex items-center space-x-2">
                              <span>{lighting.icon}</span>
                              <div>
                                <div className="font-bold text-xs flex items-center">
                                  {lighting.name}
                                  {lighting.premium && <Crown className="w-3 h-3 ml-1 text-yellow-400" />}
                                </div>
                              </div>
                            </div>
                            {lighting.premium && !hasPremiumAccess() && (
                              <Lock className="w-3 h-3 text-yellow-400" />
                            )}
                          </div>
                        </button>
                      ))}
                    </div>
                  </div>

                  {/* Mood */}
                  <div>
                    <h3 className="text-lg font-black text-white mb-4 flex items-center">
                      <Palette className="w-5 h-5 mr-2" />
                      Mood
                      <span className="text-red-400 ml-1">*</span>
                    </h3>
                    <div className="space-y-2 max-h-48 overflow-y-auto">
                      {moodOptions.map(mood => (
                        <button
                          key={mood.id}
                          onClick={() => setSelectedMood(mood.id)}
                          className={`w-full p-2 rounded-lg border transition-all text-left ${
                            selectedMood === mood.id 
                              ? `bg-gradient-to-r ${mood.gradient} border-white/30 text-white shadow-lg scale-105` 
                              : 'bg-white/5 border-white/20 text-white/80 hover:bg-white/10'
                          }`}
                        >
                          <div className="font-bold text-xs">{mood.name}</div>
                        </button>
                      ))}
                    </div>
                  </div>

                  {/* Opciones técnicas avanzadas en grid */}
                  <div className="grid grid-cols-2 gap-6">
                    {/* Estilo Visual */}
                    <div>
                      <label className="block text-white/80 text-sm font-bold mb-3">
                        <Sliders className="w-4 h-4 inline mr-2" />
                        Estilo Visual
                      </label>
                      <select
                        value={selectedStyle}
                        onChange={(e) => {
                          const styleData = visualStyles.find(s => s.id === e.target.value);
                          if (styleData?.premium && !hasPremiumAccess()) {
                            alert('Estilo exclusivo para miembros Pro');
                            return;
                          }
                          setSelectedStyle(e.target.value);
                        }}
                        className="w-full bg-black/50 border border-white/20 rounded-xl px-4 py-3 text-white font-medium focus:outline-none focus:ring-2 focus:ring-purple-500"
                      >
                        <option value="">Seleccionar...</option>
                        {visualStyles.map(style => (
                          <option key={style.id} value={style.id} disabled={style.premium && !hasPremiumAccess()}>
                            {style.name} {style.premium && !hasPremiumAccess() ? '(Pro)' : ''}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* Tipo de Cámara */}
                    <div>
                      <label className="block text-white/80 text-sm font-bold mb-3">
                        <Aperture className="w-4 h-4 inline mr-2" />
                        Tipo de Cámara
                      </label>
                      <select
                        value={selectedCameraType}
                        onChange={(e) => setSelectedCameraType(e.target.value)}
                        className="w-full bg-black/50 border border-white/20 rounded-xl px-4 py-3 text-white font-medium focus:outline-none focus:ring-2 focus:ring-purple-500"
                      >
                        <option value="">Seleccionar...</option>
                        {cameraTypes.map(camera => (
                          <option key={camera.id} value={camera.id}>
                            {camera.name}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* Color Grading */}
                    <div>
                      <label className="block text-white/80 text-sm font-bold mb-3">
                        <Palette className="w-4 h-4 inline mr-2" />
                        Color Grading
                      </label>
                      <select
                        value={selectedColorGrading}
                        onChange={(e) => setSelectedColorGrading(e.target.value)}
                        className="w-full bg-black/50 border border-white/20 rounded-xl px-4 py-3 text-white font-medium focus:outline-none focus:ring-2 focus:ring-purple-500"
                      >
                        <option value="">Seleccionar...</option>
                        {colorGradingOptions.map(grading => (
                          <option key={grading.id} value={grading.id}>
                            {grading.name}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* Nivel de Textura */}
                    <div>
                      <label className="block text-white/80 text-sm font-bold mb-3">
                        <Layers className="w-4 h-4 inline mr-2" />
                        Nivel de Textura
                      </label>
                      <select
                        value={selectedTextureDetail}
                        onChange={(e) => setSelectedTextureDetail(e.target.value)}
                        className="w-full bg-black/50 border border-white/20 rounded-xl px-4 py-3 text-white font-medium focus:outline-none focus:ring-2 focus:ring-purple-500"
                      >
                        <option value="">Seleccionar...</option>
                        {textureDetailLevels.map(texture => (
                          <option key={texture.id} value={texture.id}>
                            {texture.name}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* Ambiente */}
                    <div>
                      <label className="block text-white/80 text-sm font-bold mb-3">
                        <Camera className="w-4 h-4 inline mr-2" />
                        Ambiente
                      </label>
                      <select
                        value={selectedEnvironment}
                        onChange={(e) => setSelectedEnvironment(e.target.value)}
                        className="w-full bg-black/50 border border-white/20 rounded-xl px-4 py-3 text-white font-medium focus:outline-none focus:ring-2 focus:ring-purple-500"
                      >
                        <option value="">Seleccionar...</option>
                        {environments.map(env => (
                          <option key={env.id} value={env.id}>
                            {env.name}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* Aspect Ratio */}
                    <div>
                      <label className="block text-white/80 text-sm font-bold mb-3">
                        <Film className="w-4 h-4 inline mr-2" />
                        Aspect Ratio
                      </label>
                      <select
                        value={aspectRatio}
                        onChange={(e) => setAspectRatio(e.target.value)}
                        className="w-full bg-black/50 border border-white/20 rounded-xl px-4 py-3 text-white font-medium focus:outline-none focus:ring-2 focus:ring-purple-500"
                      >
                        <option value="1080x1350">1080x1350 (Instagram)</option>
                        <option value="1920x1080">1920x1080 (16:9)</option>
                        <option value="1080x1080">1080x1080 (Cuadrado)</option>
                        <option value="1080x1920">1080x1920 (Stories)</option>
                        <option value="3200x2400">3200x2400 (4:3 High-Res)</option>
                        <option value="4096x2160">4096x2160 (Cinema 4K)</option>
                      </select>
                    </div>
                  </div>

                  {/* Detalles Personalizados */}
                  <div>
                    <label className="block text-white/80 text-sm font-bold mb-3">
                      Detalles Personalizados Ultra-Específicos
                    </label>
                    <textarea
                      value={customText}
                      onChange={(e) => setCustomText(e.target.value)}
                      className="w-full bg-black/50 border border-white/20 rounded-xl px-4 py-4 text-white placeholder-white/50 font-medium focus:outline-none focus:ring-2 focus:ring-purple-500 resize-none"
                      placeholder="Añade detalles súper específicos: poses exactas, elementos de vestuario, texturas particulares, efectos visuales únicos, referencias de color..."
                      rows="4"
                    />
                  </div>
                </div>
              )}
            </div>

            {/* Botones de acción */}
            <div className="space-y-4">
              <button
                onClick={generateAIPrompt}
                disabled={!selectedCategory || !selectedSubject || !selectedComposition || !selectedLighting || !selectedMood || isGenerating || (!user && dailyPrompts <= 0)}
                className="w-full bg-gradient-to-r from-purple-600 via-pink-600 to-blue-600 text-white py-6 rounded-2xl font-black text-xl hover:from-purple-700 hover:via-pink-700 hover:to-blue-700 transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center space-x-3 shadow-2xl transform hover:scale-105 disabled:hover:scale-100"
              >
                <Sparkles className="w-6 h-6" />
                <span>{isGenerating ? 'Creando Obra Maestra...' : 'Generar Prompt Ultra-Profesional'}</span>
                <Award className="w-6 h-6" />
              </button>
              
              {/* Cuestionario Maestro - Solo Pro */}
              {hasPremiumAccess() && (
                <button
                  onClick={() => setShowQuestionnaire(true)}
                  className="w-full bg-gradient-to-r from-cyan-600 to-blue-600 text-white py-4 rounded-xl font-bold hover:from-cyan-700 hover:to-blue-700 transition-all flex items-center justify-center space-x-2"
                >
                  <FileText className="w-5 h-5" />
                  <span>Cuestionario Maestro (26 Preguntas)</span>
                  <Gem className="w-5 h-5" />
                </button>
              )}
            </div>
          </div>

          {/* Panel derecho - Resultado */}
          <div className="bg-black/40 backdrop-blur-xl rounded-3xl p-8 border border-white/10 shadow-2xl">
            <h2 className="text-2xl font-black text-white mb-6 flex items-center">
              <div className="w-8 h-8 bg-gradient-to-r from-green-500 to-emerald-500 rounded-lg flex items-center justify-center mr-3">
                <Zap className="w-5 h-5 text-white" />
              </div>
              Tu Obra Maestra Ultra-Detallada
            </h2>
            
            {isGenerating ? (
              <div className="text-center py-16">
                <div className="relative">
                  <div className="w-20 h-20 border-4 border-purple-500/30 border-t-purple-500 rounded-full animate-spin mx-auto mb-6"></div>
                  <div className="absolute inset-0 w-20 h-20 border-4 border-pink-500/30 border-b-pink-500 rounded-full animate-spin mx-auto animation-delay-150"></div>
                </div>
                <p className="text-white/80 text-lg font-medium mb-2">Generando prompt ultra-detallado con IA...</p>
                <p className="text-purple-300 text-sm mb-4">Aplicando técnicas de fotografía editorial de élite</p>
                <div className="bg-blue-500/10 border border-blue-500/20 rounded-xl p-4 max-w-md mx-auto">
                  <p className="text-blue-200 text-sm">🎯 Biblioteca de 100+ prompts profesionales</p>
                  <p className="text-blue-200 text-sm mt-1">⚡ Generando prompt de 900+ palabras</p>
                  <p className="text-blue-200 text-sm mt-1">🎨 Nivel de detalle: Magazine Cover Quality</p>
                </div>
                <div className="mt-6 flex items-center justify-center space-x-2">
                  <div className="w-2 h-2 bg-purple-500 rounded-full animate-pulse"></div>
                  <div className="w-2 h-2 bg-pink-500 rounded-full animate-pulse delay-150"></div>
                  <div className="w-2 h-2 bg-blue-500 rounded-full animate-pulse delay-300"></div>
                </div>
              </div>
            ) : generatedPrompt ? (
              <div className="space-y-6">
                <div className="bg-black/60 rounded-2xl p-6 border border-white/10 max-h-80 overflow-y-auto">
                  <div className="flex items-center justify-between mb-4">
                    <span className="text-white/60 text-sm font-medium">
                      📝 {generatedPrompt.length} caracteres | 🎯 Nivel Profesional
                    </span>
                    <div className="flex items-center space-x-2">
                      <button
                        onClick={() => setShowExportModal(true)}
                        className="text-white/60 hover:text-white transition-colors"
                      >
                        <Download className="w-5 h-5" />
                      </button>
                      <button
                        onClick={() => {
                          if (navigator.share) {
                            navigator.share({
                              title: 'PromptStudio Professional Prompt',
                              text: generatedPrompt
                            });
                          }
                        }}
                        className="text-white/60 hover:text-white transition-colors"
                      >
                        <Share2 className="w-5 h-5" />
                      </button>
                    </div>
                  </div>
                  <p className="text-white/90 leading-relaxed text-sm font-medium whitespace-pre-wrap">{generatedPrompt}</p>
                </div>
                
                <div className="flex space-x-4">
                  <button
                    onClick={copyPrompt}
                    className="flex-1 bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700 text-white py-4 px-6 rounded-xl font-bold transition-all duration-300 flex items-center justify-center space-x-2 shadow-xl transform hover:scale-105"
                  >
                    {copied ? <Check className="w-5 h-5" /> : <Copy className="w-5 h-5" />}
                    <span>{copied ? '¡Copiado!' : 'Copiar Prompt'}</span>
                  </button>
                  
                  <button
                    onClick={resetForm}
                    className="bg-gradient-to-r from-gray-600 to-gray-700 hover:from-gray-700 hover:to-gray-800 text-white py-4 px-6 rounded-xl font-bold transition-all duration-300 transform hover:scale-105"
                  >
                    Nuevo Prompt
                  </button>
                </div>

                <div className="bg-gradient-to-r from-emerald-500/20 to-green-500/20 border border-emerald-500/30 rounded-2xl p-6">
                  <h3 className="text-emerald-300 font-black mb-3 flex items-center">
                    <Award className="w-5 h-5 mr-2" />
                    Prompt Ultra-Profesional de Élite Generado
                  </h3>
                  <div className="text-emerald-200/90 text-sm space-y-2 font-medium">
                    <p>✓ Técnicas de fotografía editorial premium aplicadas</p>
                    <p>✓ Especificaciones técnicas ultra-detalladas</p>
                    <p>✓ Basado en biblioteca de 100+ prompts profesionales</p>
                    <p>✓ Optimizado para resultados de Magazine Cover Quality</p>
                    <p>✓ Compatible con DALL-E, Midjourney, Stable Diffusion</p>
                    <p>✓ Nivel de detalle: Comercial y editorial premium</p>
                  </div>
                </div>
              </div>
            ) : (
              <div className="text-center py-20">
                <div className="w-24 h-24 bg-gradient-to-r from-purple-500/20 to-blue-500/20 rounded-full flex items-center justify-center mx-auto mb-6">
                  <Camera className="w-12 h-12 text-white/40" />
                </div>
                <p className="text-white/60 text-lg font-medium mb-3">
                  Completa las selecciones requeridas (*)
                </p>
                <p className="text-white/40 text-sm mb-4">
                  La IA generará un prompt ultra-detallado basado en 100+ templates de expertos
                </p>
                <div className="bg-purple-500/10 border border-purple-500/20 rounded-xl p-4 max-w-md mx-auto">
                  <p className="text-purple-200 text-sm">🎯 12 categorías profesionales</p>
                  <p className="text-purple-200 text-sm mt-1">⚡ 100+ combinaciones de estilos premium</p>
                  <p className="text-purple-200 text-sm mt-1">🎨 Prompts técnicos ultra-específicos</p>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Call to Action premium para usuarios no registrados */}
        {!user && (
          <div className="mt-16 relative">
            <div className="absolute inset-0 bg-gradient-to-r from-purple-600/20 to-blue-600/20 rounded-3xl blur-xl"></div>
            <div className="relative bg-gradient-to-r from-purple-900/80 to-blue-900/80 backdrop-blur-xl rounded-3xl p-12 text-center border border-white/20 shadow-2xl">
              <div className="flex items-center justify-center mb-6">
                <Crown className="w-12 h-12 text-yellow-400 mr-3" />
                <h2 className="text-4xl font-black text-white">¿Listo para el Poder Total?</h2>
                <Gem className="w-12 h-12 text-blue-400 ml-3" />
              </div>
              <p className="text-white/90 text-xl mb-4 font-medium">
                Únete a la élite creativa. Acceso ilimitado a prompts ultra-profesionales.
              </p>
              <p className="text-white/70 text-lg mb-8">
                🎯 12 Categorías | ⚡ 100+ Estilos Premium | 🎨 Prompts de 900+ palabras
              </p>
              <div className="flex flex-col sm:flex-row gap-6 justify-center max-w-lg mx-auto">
                <button 
                  onClick={() => setShowAuth(true)}
                  className="bg-gradient-to-r from-white to-gray-100 text-purple-900 px-8 py-4 rounded-xl font-black text-lg hover:from-gray-100 hover:to-white transition-all transform hover:scale-105 shadow-xl"
                >
                  Registrarse Gratis
                </button>
                <button 
                  onClick={() => setShowPricing(true)}
                  className="bg-gradient-to-r from-yellow-400 to-orange-500 text-black px-8 py-4 rounded-xl font-black text-lg hover:from-yellow-300 hover:to-orange-400 transition-all transform hover:scale-105 shadow-xl"
                >
                  Ver Planes Élite
                </button>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Modal de autenticación mejorado */}
      {showAuth && (
        <div className="fixed inset-0 bg-black/70 backdrop-blur-lg flex items-center justify-center p-4 z-50">
          <div className="bg-gradient-to-br from-gray-900 to-black rounded-3xl p-8 w-full max-w-md relative border border-white/20 shadow-2xl">
            <button
              onClick={() => setShowAuth(false)}
              className="absolute top-6 right-6 text-white/60 hover:text-white text-2xl transition-colors"
            >
              ×
            </button>
            
            <div className="text-center mb-8">
              <div className="w-16 h-16 bg-gradient-to-r from-purple-500 to-blue-500 rounded-2xl flex items-center justify-center mx-auto mb-4">
                <Sparkles className="w-8 h-8 text-white" />
              </div>
              <h2 className="text-3xl font-black text-white mb-2">
                {isLogin ? 'Bienvenido de Vuelta' : 'Únete a la Élite'}
              </h2>
              <p className="text-white/70 font-medium">
                {isLogin ? 'Accede a tu estudio profesional' : 'Crea tu cuenta de élite'}
              </p>
            </div>

            <div className="space-y-6">
              {!isLogin && (
                <div>
                  <label className="block text-sm font-bold text-white/80 mb-2">
                    Nombre Completo
                  </label>
                  <div className="relative">
                    <User className="absolute left-4 top-1/2 transform -translate-y-1/2 w-5 h-5 text-white/50" />
                    <input
                      type="text"
                      value={authForm.name}
                      onChange={(e) => setAuthForm(prev => ({...prev, name: e.target.value}))}
                      className="w-full pl-12 pr-4 py-4 bg-black/50 border border-white/20 rounded-xl text-white placeholder-white/50 font-medium focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                      placeholder="Tu nombre"
                    />
                  </div>
                </div>
              )}

              <div>
                <label className="block text-sm font-bold text-white/80 mb-2">
                  Email
                </label>
                <div className="relative">
                  <Mail className="absolute left-4 top-1/2 transform -translate-y-1/2 w-5 h-5 text-white/50" />
                  <input
                    type="email"
                    value={authForm.email}
                    onChange={(e) => setAuthForm(prev => ({...prev, email: e.target.value}))}
                    className="w-full pl-12 pr-4 py-4 bg-black/50 border border-white/20 rounded-xl text-white placeholder-white/50 font-medium focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                    placeholder="tu@email.com"
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm font-bold text-white/80 mb-2">
                  Contraseña
                </label>
                <div className="relative">
                  <Lock className="absolute left-4 top-1/2 transform -translate-y-1/2 w-5 h-5 text-white/50" />
                  <input
                    type={showPassword ? 'text' : 'password'}
                    value={authForm.password}
                    onChange={(e) => setAuthForm(prev => ({...prev, password: e.target.value}))}
                    className="w-full pl-12 pr-12 py-4 bg-black/50 border border-white/20 rounded-xl text-white placeholder-white/50 font-medium focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                    placeholder="••••••••"
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className="absolute right-4 top-1/2 transform -translate-y-1/2 text-white/50 hover:text-white/80 transition-colors"
                  >
                    {showPassword ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
                  </button>
                </div>
              </div>

              <button
                onClick={handleAuth}
                className="w-full bg-gradient-to-r from-purple-600 to-blue-600 text-white py-4 rounded-xl font-black text-lg hover:from-purple-700 hover:to-blue-700 transition-all transform hover:scale-105 shadow-xl"
              >
                {isLogin ? 'Entrar al Estudio' : 'Crear Cuenta Élite'}
              </button>

              <div className="relative">
                <div className="absolute inset-0 flex items-center">
                  <div className="w-full border-t border-white/20"></div>
                </div>
                <div className="relative flex justify-center text-sm">
                  <span className="bg-black px-2 text-white/60">O continúa con</span>
                </div>
              </div>

              <button
                onClick={loginWithGoogle}
                className="w-full bg-white text-black py-4 rounded-xl font-bold text-lg hover:bg-gray-100 transition-all flex items-center justify-center space-x-3"
              >
                <Globe className="w-5 h-5" />
                <span>Google</span>
              </button>
            </div>

            <div className="mt-6 text-center">
              <button
                onClick={() => setIsLogin(!isLogin)}
                className="text-purple-400 hover:text-purple-300 font-medium transition-colors"
              >
                {isLogin ? '¿Nuevo en PromptStudio? Crear cuenta' : '¿Ya tienes cuenta? Iniciar sesión'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal de Pricing y Suscripciones */}
      {showPricing && (
        <div className="fixed inset-0 bg-black/70 backdrop-blur-lg flex items-center justify-center p-4 z-50">
          <div className="bg-gradient-to-br from-gray-900 to-black rounded-3xl p-8 w-full max-w-4xl relative border border-white/20 shadow-2xl max-h-[90vh] overflow-y-auto">
            <button
              onClick={() => setShowPricing(false)}
              className="absolute top-6 right-6 text-white/60 hover:text-white text-2xl transition-colors z-10"
            >
              ×
            </button>
            
            <div className="text-center mb-8">
              <h2 className="text-4xl font-black text-white mb-4">
                Elige tu Plan de Élite
              </h2>
              <p className="text-white/70 text-xl font-medium">
                Desbloquea todo el poder de PromptStudio
              </p>
            </div>

            {/* Plan Gratuito */}
            <div className="mb-8">
              <div className="bg-white/5 border border-white/20 rounded-2xl p-6">
                <div className="flex items-center justify-between">
                  <div>
                    <h3 className="text-2xl font-bold text-white mb-2">Plan Gratuito</h3>
                    <p className="text-white/60">Perfecto para empezar</p>
                    <div className="mt-4 space-y-2">
                      <div className="flex items-center text-white/80">
                        <Check className="w-4 h-4 mr-2 text-green-400" />
                        <span className="text-sm">3 prompts profesionales por día</span>
                      </div>
                      <div className="flex items-center text-white/80">
                        <Check className="w-4 h-4 mr-2 text-green-400" />
                        <span className="text-sm">Acceso a estilos básicos</span>
                      </div>
                      <div className="flex items-center text-white/80">
                        <Check className="w-4 h-4 mr-2 text-green-400" />
                        <span className="text-sm">Biblioteca de referencias básica</span>
                      </div>
                    </div>
                  </div>
                  <div className="text-right">
                    <div className="text-3xl font-black text-white">Gratis</div>
                    <div className="text-white/60">para siempre</div>
                  </div>
                </div>
              </div>
            </div>

            {/* Planes Premium */}
            <div className="grid md:grid-cols-2 gap-6">
              {Object.values(subscriptionPlans).map(plan => (
                <div 
                  key={plan.id}
                  className={`relative rounded-2xl p-8 border transition-all duration-300 ${
                    plan.popular 
                      ? 'bg-gradient-to-br from-blue-600/20 to-purple-600/20 border-blue-500/50 scale-105' 
                      : 'bg-white/5 border-white/20 hover:border-white/30'
                  }`}
                >
                  {plan.popular && (
                    <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                      <span className="bg-gradient-to-r from-blue-500 to-purple-500 text-white px-4 py-2 rounded-full text-sm font-bold">
                        MÁS POPULAR
                      </span>
                    </div>
                  )}
                  
                  <div className="text-center mb-6">
                    <h3 className="text-2xl font-bold text-white mb-2">{plan.name}</h3>
                    <div className="mb-4">
                      <span className="text-4xl font-black text-white">${plan.price}</span>
                      <span className="text-white/60 ml-2">USD/{plan.interval}</span>
                    </div>
                  </div>

                  <div className="space-y-3 mb-8">
                    {plan.features.map((feature, index) => (
                      <div key={index} className="flex items-center text-white/80">
                        <Check className="w-4 h-4 mr-3 text-green-400 flex-shrink-0" />
                        <span className="text-sm">{feature}</span>
                      </div>
                    ))}
                  </div>

                  <div className="space-y-4">
                    {!user ? (
                      <button
                        onClick={() => {
                          setSelectedPlan(plan.id);
                          setShowPricing(false);
                          setShowAuth(true);
                        }}
                        className={`w-full py-4 rounded-xl font-bold text-lg transition-all transform hover:scale-105 ${
                          plan.popular
                            ? 'bg-gradient-to-r from-blue-600 to-purple-600 text-white hover:from-blue-700 hover:to-purple-700'
                            : 'bg-white text-black hover:bg-gray-100'
                        }`}
                      >
                        Comenzar Plan {plan.name}
                      </button>
                    ) : user.plan === 'free' ? (
                      <button
                        onClick={() => createPayPalSubscription(plan.id)}
                        disabled={isProcessingPayment}
                        className={`w-full py-4 rounded-xl font-bold text-lg transition-all transform hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed ${
                          plan.popular
                            ? 'bg-gradient-to-r from-blue-600 to-purple-600 text-white hover:from-blue-700 hover:to-purple-700'
                            : 'bg-white text-black hover:bg-gray-100'
                        }`}
                      >
                        {isProcessingPayment ? (
                          <div className="flex items-center justify-center">
                            <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin mr-2"></div>
                            Procesando...
                          </div>
                        ) : (
                          `Upgrade a ${plan.name}`
                        )}
                      </button>
                    ) : user.plan === plan.id ? (
                      <div className="space-y-2">
                        <div className="w-full py-4 rounded-xl bg-green-600 text-white text-center font-bold">
                          ✅ Plan Actual
                        </div>
                        <button
                          onClick={cancelSubscription}
                          className="w-full py-2 rounded-xl bg-red-600/20 text-red-300 hover:bg-red-600/30 transition-colors text-sm"
                        >
                          Cancelar Suscripción
                        </button>
                      </div>
                    ) : (
                      <button
                        onClick={() => createPayPalSubscription(plan.id)}
                        disabled={isProcessingPayment}
                        className="w-full py-4 rounded-xl bg-white/10 text-white hover:bg-white/20 transition-colors font-bold"
                      >
                        Cambiar a {plan.name}
                      </button>
                    )}
                  </div>
                </div>
              ))}
            </div>

            {/* Información adicional */}
            <div className="mt-8 text-center">
              <div className="bg-blue-500/10 border border-blue-500/20 rounded-xl p-6">
                <h4 className="text-white font-bold mb-2 flex items-center justify-center">
                  <Shield className="w-5 h-5 mr-2" />
                  💳 Procesado por PayPal
                </h4>
                <p className="text-white/70 text-sm">
                  Pagos seguros y confiables. Cancela en cualquier momento. Sin compromisos de largo plazo.
                </p>
                <div className="flex items-center justify-center mt-4 space-x-4 text-white/60 text-xs">
                  <span className="flex items-center"><Lock className="w-3 h-3 mr-1" /> Seguro SSL</span>
                  <span className="flex items-center"><DollarSign className="w-3 h-3 mr-1" /> Garantía 30 días</span>
                  <span className="flex items-center"><Globe className="w-3 h-3 mr-1" /> Pagos internacionales</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal de Exportación */}
      {showExportModal && (
        <div className="fixed inset-0 bg-black/70 backdrop-blur-lg flex items-center justify-center p-4 z-50">
          <div className="bg-gradient-to-br from-gray-900 to-black rounded-3xl p-8 w-full max-w-md relative border border-white/20 shadow-2xl">
            <button
              onClick={() => setShowExportModal(false)}
              className="absolute top-6 right-6 text-white/60 hover:text-white text-2xl transition-colors"
            >
              ×
            </button>
            
            <h3 className="text-2xl font-black text-white mb-6">Exportar Prompt</h3>
            
            <div className="space-y-4">
              <button
                onClick={() => exportPrompt('txt')}
                className="w-full bg-white/10 text-white py-4 rounded-xl font-bold hover:bg-white/20 transition-colors flex items-center justify-center space-x-2"
              >
                <FileText className="w-5 h-5" />
                <span>Exportar como TXT</span>
              </button>
              
              <button
                onClick={() => exportPrompt('json')}
                className="w-full bg-white/10 text-white py-4 rounded-xl font-bold hover:bg-white/20 transition-colors flex items-center justify-center space-x-2"
              >
                <Save className="w-5 h-5" />
                <span>Exportar como JSON</span>
              </button>
            </div>
          </div>
        </div>
      )}
      {user && askWhatsapp && (
  <WhatsAppModal
    onClose={() => setAskWhatsapp(false)}
    onSave={saveWhatsapp}
  />
)}
    </div>
  );
};

export default PromptStudio;
